import { render } from "./WarmTransferScript.vue?vue&type=template&id=61c19f6c"
import script from "./WarmTransferScript.vue?vue&type=script&lang=js"
export * from "./WarmTransferScript.vue?vue&type=script&lang=js"
script.render = render

export default script